<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/self-service" class="opacity-50 hover:opacity-100">Self Services</router-link>
                        <span class="mx-2">/</span>
                        <span>{{ getTitle }}</span>
                    </div>
                    <div class="font-bold">{{ getTitle }}</div>
                </div>
                <section class="mt-8 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-start" :class="{ invalid: !submittedTo.isValid }">
                        <label for="submitted-to" class="flex-shrink-0 mr-4 mt-2">Submitted To</label>
                        <div class="flex-grow">
                            <input id="submitted-to" type="text" v-model="submittedTo.val" @blur="clearValidity('submittedTo')">
                            <transition name="fade" mode="out-in">
                                <p v-if="!submittedTo.isValid" class="h-4 text-xs text-red-600">
                                    {{ submittedTo.msg }}
                                </p>
                            </transition>
                        </div>
                    </div>
                    <div class="flex justify-center mt-8">
                        <div @click.stop="submitForm" class="flex items-center bg-ternary hover:bg-white border-ternary border px-4 py-2 rounded-lg cursor-pointer text-white hover:text-ternary">Submit</div>
                    </div>
                </section>
            </div>
        </div>
        <base-page-spinner v-if="isLoading" type="spin" class-list="h-20"></base-page-spinner>
        <transition name="fade" mode="out-in">
            <base-full-modal v-if="isOpenModal" title="To Whom it may concern(Continuing Study)" @close="closeModal">
                <iframe :src="previewFile" class="h-screen"></iframe>
            </base-full-modal>
        </transition>
    </div>
</template>

<script>
import gql from 'graphql-tag';
export default {
    name: "to-whom-it-may-concern-continuing-study",
    data() {
        return {
            submittedTo: {
                val: "",
                isValid: true,
                msg: "",
            },
            formIsValid: true,
            isLoading: false,
            isOpenModal: false,
            previewFile: "",
            selfService: [],
            selectedSelfService: null
        };
    },
    created() {
        const selectedSelfServiceJson = localStorage.getItem("selectedSelfService");
        if (selectedSelfServiceJson) {
            const selectedSelfService = JSON.parse(selectedSelfServiceJson);
            if (selectedSelfService.url === this.$route.fullPath) {
                this.selectedSelfService = selectedSelfService;
            } else {
                this.fetchSelfService();
            }
        } else {
            this.fetchSelfService();
        }
    },
    computed: {
        getTitle() {
            if (this.selectedSelfService) {
                return this.selectedSelfService.title;
            } else {
                return this.selfService.title;
            }
        },
        submittedToList() {
            if (this.selectedSelfService) {
                return this.selectedSelfService.submitted_to;
            } else {
                return this.selfService.submitted_to;
            }
        },
        getFormId() {
            if (this.selectedSelfService) {
                return this.selectedSelfService.id;
            } else {
                return this.selfService.id;
            }
        },
    },
    methods: {
        async fetchSelfService() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GetSelfServiceDetails($url: String!) {
                            selfService(url: $url) {
                                id
                                title
                            }
                        }
                    `,
                    variables: {
                        url: '%self-service/to-whom-it-may-concern-continuing-study%',
                    },
                    fetchPolicy: 'network-only',
                });
                this.selfService = data.selfService;
            } catch (error) {
                console.error(error);
            }
        },
        clearValidity(input) {
            this[input].isValid = true;
            this[input].msg = "";
        },
        validateForm() {
            this.formIsValid = true;
            
            if (this.submittedTo.val === "") {
                this.submittedTo.isValid = false;
                this.submittedTo.msg = "You must select an option";
                this.formIsValid = false;
            }
            
        },
        async submitForm() {
            this.validateForm();

            if (!this.formIsValid) {
                return;
            }

            const CREATE_MUTATION = gql`
                mutation SelfServiceToWhomItMayConcernContinuinfStudy($service_type: String!, $submitted_to: String!, $form_id: ID!) {
                    createSelfService(service_type: $service_type, submitted_to: $submitted_to, form_id: $form_id) {
                        error
                        error_code
                        message
                        url
                    }
                }
            `;

            this.isLoading = true;
            let error_msg = '';

            try {
                await this.$apollo.mutate({
                    mutation: CREATE_MUTATION,
                    variables: {
                        service_type: 'to-whom-it-may-concern-continuing-study',
                        submitted_to: this.submittedTo.val,
                        form_id: parseInt(this.getFormId),
                    }
                }).then((data) => {
                    if (data.data.createSelfService.error) {
                        error_msg = data.data.createSelfService.message;
                    } else {
                        this.previewFile = process.env.VUE_APP_PUBLIC_URL + data.data.createSelfService.url;
                    }
                }).catch((error) => {
                    error_msg = error;
                })

            } catch (error) {
                error_msg = error.message || "Failed to authenticate, try later.";
            }

            this.isLoading = false;

            if (error_msg) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error_msg,
                }).then((result) => {
                    console.log(result);
                })
            } else {
                this.isOpenModal = true;
            }

            
        },
        closeModal() {
            this.isOpenModal = false;
            this.previewFile = "";
        },
    },
    beforeUnmount() {
        localStorage.removeItem("selectedSelfService");
        this.selectedSelfService = null;
    },
}
</script>

<style lang="scss" scoped>
input[type="text"] {
  @apply block w-full border rounded-lg py-2 px-2;
}
input[type="text"]:focus {
  outline: none;
  border-color: #394867;
  box-shadow: 0 0 0 1px #394867;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  height: 0px;
}
</style>